import { APP_ROUTES } from "../constants";

export const BlogUtil = {
  buildBlogDetailPath,
  buildTags,
  buildPromotionDetailPath,
};

function buildBlogDetailPath(code: string): string {
  return code ? APP_ROUTES.BLOG.BLOG_DETAIL.replace(":code", code) : APP_ROUTES.BLOG.BASE;
}

function buildPromotionDetailPath(blogId: string): string {
  return blogId ? APP_ROUTES.PROMOTION.PROMOTION_DETAIL.replace(":promotionId", blogId) : APP_ROUTES.PROMOTION.BASE;
}

function buildTags(tagStr: string): string[] {
  if (!tagStr) {
    return [];
  }

  let tags: string[] = tagStr.split("|");

  tags = tags.filter((tag) => {
    return !!tag.trim();
  });

  return tags;
}
